// extracted by mini-css-extract-plugin
export default {"revenueContent":"Subscriptions_revenueContent__3fIKA"};